import MetaTags from "react-meta-tags"
import React, { useEffect, useState } from "react"
import {
  useStyles,
  Wrapper,
  WrapperLogin,
  LoginFormDocPlace,
  WrapperFormDocPlace,
  SecurityBadge,
  SecurityHeader,
  PasswordRequirementsList,
  PasswordRequirement,
  PasswordStrengthMeter,
  PasswordMatchIndicator,
} from './style';
import { Container, Label } from "reactstrap"
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LockIcon from '@mui/icons-material/Lock';
import ShieldIcon from '@mui/icons-material/Shield';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import logoFD from '../../assets/logoColorsDocPlace.png';

import { useSelector, useDispatch } from "react-redux"
import { resetPassword, resetApp } from "../../store/actions"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InputDocPlace from "../../components/form/input";
import LoadingComponent from "../../components/loading";
import { expressions } from "../../components/theme";
import { useNavigate } from "react-router-dom";

const ResetPassword = (props) => {
  const classes = useStyles();
  const notify = (msj, event) => toast[event](msj);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [password, setPassword] = useState({ value: '', error: false });
  const [passwordRepeat, setPasswordRepeat] = useState({ value: '', error: false });
  const [passwordErr, setPasswordErr] = useState('');
  const [passwordRepeatErr, setPasswordRepeatErr] = useState('');
  const [hasError, setError] = useState(false);
  const [rMessage, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordRepeat, setShowPasswordRepeat] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [passwordRequirements, setPasswordRequirements] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    match: false
  });

  //get url parameters (support both new ?token= and legacy ?hash=)
  const queryParams = new URLSearchParams(window.location.search)
  const token = queryParams.get("token") || queryParams.get("hash");
  //behavior page
  const [ready, setReady] = useState(true);
  const { responseReset, errorReset, loading } = useSelector(state => ({  //Hook to have the responses from redux
    responseReset: state.Login.responseResetPassword,
    errorReset: state.Login.errorResetPassword,
    loading: state.Login.loadingResetPassword,
  }));

  useEffect(() => {
    let ignore = false;
    if (!ignore) {
      if (!token) {
        setReady(false);
        setError(true);
        notify("Incorrect request, we can't process your password change in this moment", "error");
      }
    }
    return () => { ignore = true; };
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  // Password strength and requirements validation
  useEffect(() => {
    const pwd = password.value;
    const pwdRepeat = passwordRepeat.value;

    const requirements = {
      length: pwd.length >= 8,
      uppercase: /[A-Z]/.test(pwd),
      lowercase: /[a-z]/.test(pwd),
      number: /[0-9]/.test(pwd),
      match: pwd.length > 0 && pwd === pwdRepeat
    };

    setPasswordRequirements(requirements);

    // Calculate strength (0-4)
    let strength = 0;
    if (requirements.length) strength++;
    if (requirements.uppercase) strength++;
    if (requirements.lowercase) strength++;
    if (requirements.number) strength++;

    setPasswordStrength(strength);
  }, [password.value, passwordRepeat.value]);

  /**Hook for actions after the success response */
  useEffect(() => {
    if (responseReset?.success) {
      notify("Your password was successfully reset.", "success");
      setMessage("Your password was successfully reset, you can now log in with your new password.");
      setError(false);
    }
    if (errorReset) {
      const messages = errorReset?.response?.data?.error?.messages;
      const apiMessage = Array.isArray(messages) && messages.length > 0
        ? messages.map((m) => m.message).join(" ")
        : "We can't change your password at this moment due expired or incorrect request.";
      notify(apiMessage, "error");
      setMessage(apiMessage);
      setError(true);
    }
    if (errorReset || responseReset) setReady(false);

  }, [responseReset, errorReset]);


  const handleValidSubmit = (e) => {
    e.preventDefault();
    const uppercaseRegExp = /(?=.*?[A-Z])/;
    const lowercaseRegExp = /(?=.*?[a-z])/;
    const digitsRegExp = /(?=.*?[0-9])/;
    const _specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
    void _specialCharRegExp;
    const minLengthRegExp = /.{8,}/;
    const passwordLength = password.value.length;
    const uppercasePassword = uppercaseRegExp.test(password.value);
    const lowercasePassword = lowercaseRegExp.test(password.value);
    const digitsPassword = digitsRegExp.test(password.value);
    const minLengthPassword = minLengthRegExp.test(password.value);
    let errMsg = "";
    setPasswordRepeatErr("")
    setPasswordRepeat({ ...password, error: false })


    if (passwordLength === 0) {
      errMsg = "Your new password must be at least 8 characters length and contain uppercase and lowercase characters, and at least one number";
      setPasswordRepeat({ ...password, error: true })
    } else if (!uppercasePassword) {
      errMsg = "Your new password must be at least 8 characters length and contain uppercase and lowercase characters, and at least one number";
      setPasswordRepeat({ ...password, error: true })
    } else if (!lowercasePassword) {
      errMsg = "Your new password must be at least 8 characters length and contain uppercase and lowercase characters, and at least one number";
      setPasswordRepeat({ ...password, error: true })
    } else if (!digitsPassword) {
      errMsg = "Your new password must be at least 8 characters length and contain uppercase and lowercase characters, and at least one number";
      setPasswordRepeat({ ...password, error: true })
    } else if (!minLengthPassword) {
      errMsg = "Your new password must be at least 8 characters length and contain uppercase and lowercase characters, and at least one number";
      setPasswordRepeat({ ...password, error: true })
    } else if (password.value !== passwordRepeat.value) {
      setPasswordRepeatErr("The password does not match");
      setPasswordRepeat({ ...passwordRepeat, error: true });
    }
    else {  //password correct
      errMsg = "";
      // New API expects flat body: { Hashcode, Password, PasswordConfirmation }
      const payload = {
        Hashcode: token,
        Password: password.value,
        PasswordConfirmation: passwordRepeat.value,
      };
      dispatch(resetPassword(payload, navigate));
    }
    setPasswordErr(errMsg);

  }

  /**after a successfully email link generation, the user can navigate back to login */
  const navigateLogin = (e) => {
    setReady(false);
    setError(false);
    dispatch(resetApp());  //reset redux auth to default values, clearing up for next time.
    navigate("/login");
  }

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  }

  const handleClickShowPasswordRepeat = () => {
    setShowPasswordRepeat(!showPasswordRepeat);
  }

  const getStrengthColor = () => {
    if (passwordStrength === 0) return '#d32f2f';
    if (passwordStrength === 1) return '#f57c00';
    if (passwordStrength === 2) return '#fbc02d';
    if (passwordStrength === 3) return '#689f38';
    return '#2e7d32';
  }

  const getStrengthLabel = () => {
    if (passwordStrength === 0) return 'Very Weak';
    if (passwordStrength === 1) return 'Weak';
    if (passwordStrength === 2) return 'Fair';
    if (passwordStrength === 3) return 'Good';
    return 'Strong';
  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>Password Reset - Secure</title>
      </MetaTags>
      <div className="auth-page">
        <Container fluid className="p-0">
          <ToastContainer autoClose={3000} />
          <LoadingComponent show={loading} text={"Changing Password..."} />
          <Wrapper>
            <WrapperLogin>
              <img alt="docplace" className={classes.imgLogo} src={logoFD} />

              {ready && (
                <SecurityHeader>
                  <ShieldIcon className={classes.securityIcon} />
                  <div>
                    <h2 className={classes.securityTitle}>Secure Password Reset</h2>
                    <p className={classes.securitySubtitle}>Create a strong password to protect your account</p>
                  </div>
                </SecurityHeader>
              )}

              <LoginFormDocPlace onSubmit={handleValidSubmit}>
                <WrapperFormDocPlace>

                  {ready && (
                    <>
                      <SecurityBadge>
                        <VerifiedUserIcon style={{ fontSize: '16px', marginRight: '6px' }} />
                        <span>256-bit Encryption Protected</span>
                      </SecurityBadge>

                      <InputDocPlace
                        id={'password'}
                        field={password}
                        setField={setPassword}
                        required={true}
                        type={showPassword ? 'text' : 'password'}
                        label="New Password"
                        expresionRegular={expressions.password}
                        helperText={passwordErr}
                      />

                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        edge="end"
                        style={{
                          position: 'absolute',
                          right: '35px',
                          marginTop: '-55px',
                          zIndex: 10
                        }}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>

                      {password.value && (
                        <PasswordStrengthMeter strengthColor={getStrengthColor()}>
                          <div className="strength-bar">
                            <div
                              className="strength-fill"
                              style={{
                                width: `${(passwordStrength / 4) * 100}%`,
                                backgroundColor: getStrengthColor()
                              }}
                            />
                          </div>
                          <span className="strength-label">
                            Password Strength: <strong>{getStrengthLabel()}</strong>
                          </span>
                        </PasswordStrengthMeter>
                      )}

                      <PasswordRequirementsList>
                        <div className={classes.requirementsTitle}>
                          <LockIcon style={{ fontSize: '16px', marginRight: '6px' }} />
                          Password Requirements:
                        </div>
                        <PasswordRequirement met={passwordRequirements.length}>
                          {passwordRequirements.length ?
                            <CheckCircleIcon className="icon-met" /> :
                            <CancelIcon className="icon-not-met" />
                          }
                          At least 8 characters
                        </PasswordRequirement>
                        <PasswordRequirement met={passwordRequirements.uppercase}>
                          {passwordRequirements.uppercase ?
                            <CheckCircleIcon className="icon-met" /> :
                            <CancelIcon className="icon-not-met" />
                          }
                          One uppercase letter (A-Z)
                        </PasswordRequirement>
                        <PasswordRequirement met={passwordRequirements.lowercase}>
                          {passwordRequirements.lowercase ?
                            <CheckCircleIcon className="icon-met" /> :
                            <CancelIcon className="icon-not-met" />
                          }
                          One lowercase letter (a-z)
                        </PasswordRequirement>
                        <PasswordRequirement met={passwordRequirements.number}>
                          {passwordRequirements.number ?
                            <CheckCircleIcon className="icon-met" /> :
                            <CancelIcon className="icon-not-met" />
                          }
                          One number (0-9)
                        </PasswordRequirement>
                      </PasswordRequirementsList>

                      <InputDocPlace
                        id={'passwordRepeat'}
                        field={passwordRepeat}
                        setField={setPasswordRepeat}
                        required={true}
                        type={showPasswordRepeat ? 'text' : 'password'}
                        label="Confirm Password"
                        helperText={passwordRepeatErr}
                      />

                      <IconButton
                        aria-label="toggle password repeat visibility"
                        onClick={handleClickShowPasswordRepeat}
                        edge="end"
                        style={{
                          position: 'absolute',
                          right: '35px',
                          marginTop: '-55px',
                          zIndex: 10
                        }}
                      >
                        {showPasswordRepeat ? <VisibilityOff /> : <Visibility />}
                      </IconButton>

                      {passwordRepeat.value && (
                        <PasswordMatchIndicator matched={passwordRequirements.match}>
                          {passwordRequirements.match ? (
                            <>
                              <CheckCircleIcon className="icon-matched" />
                              <span>Passwords match</span>
                            </>
                          ) : (
                            <>
                              <CancelIcon className="icon-not-matched" />
                              <span>Passwords do not match</span>
                            </>
                          )}
                        </PasswordMatchIndicator>
                      )}

                      <Button
                        type="submit"
                        className={classes.buttons}
                        disabled={passwordStrength < 4 || !passwordRequirements.match}
                        variant="contained"
                        color="success"
                        startIcon={<LockIcon />}
                      >
                        Set Secure Password
                      </Button>
                    </>
                  )}

                  {!ready && (
                    <Label style={{ color: hasError ? 'red' : '#2e7d32', fontSize: '14px', lineHeight: '1.6' }}>
                      {rMessage}
                    </Label>
                  )}

                  {!ready && (
                    <>
                      <br />
                      <br />
                      <Button
                        type="button"
                        onClick={navigateLogin}
                        className={classes.buttons}
                        variant="contained"
                        color="success"
                      >
                        Go to Login
                      </Button>
                    </>
                  )}

                </WrapperFormDocPlace>
              </LoginFormDocPlace>
            </WrapperLogin>
          </Wrapper>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ResetPassword
